import {
  API_ROOT,
  dispatchGetJSONAsync,
  dispatchPostJSONAsync,
  completeJSONAsync,
} from './BaseApi';
import appdata from '../Services/appdata';

const ApiSummary = () => {
  const getSummary = async (dimdate) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');

    var queryjson = [];
    queryjson[0] = dimdate;
    let filter = { DimDateKey: queryjson };

    queryParams += '?filter=' + JSON.stringify(filter);
    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/summary/${company_id}/${company_org_id}/summary${queryParams}`,
    );
    if (!task) {
      return [];
    }

    return await completeJSONAsync(task);
  };

  const setSummary = async (dimdate, content) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id; // db company id
    const company_org_id = appdata.getItem('company_org_id');

    var queryjson = [];
    queryjson[0] = dimdate;
    let filter = { DimDateKey: queryjson };
    queryParams += '?filter=' + JSON.stringify(filter);
    let task = await dispatchPostJSONAsync(
      `${API_ROOT}/summary/${company_id}/${company_org_id}/setsummary${queryParams}`,
      { content },
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  const getAllSummaries = async (endDate) => {
    const company_id = appdata.getItem('company').id; // db company id
    const company_org_id = appdata.getItem('company_org_id');
    let queryParams = '';
    if (endDate) {
      queryParams = `?endDate=${endDate}`;
    }
    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/summary/${company_id}/${company_org_id}/all${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  const generateAISummary = async (priorSummaries, reportingData, defaultDimDate) => {
    const company_id = appdata.getItem('company').id; // db company id
    const company_org_id = appdata.getItem('company_org_id');
    let task = await dispatchPostJSONAsync(
      `${API_ROOT}/summary/${company_id}/${company_org_id}/generate-ai-summary`,
      { priorSummaries, reportingData, defaultDimDate },
    );
    if (!task) {
      return { error: 'Failed to generate AI summary' };
    }
    return await completeJSONAsync(task);
  };

  return {
    getSummary,
    setSummary,
    getAllSummaries,
    generateAISummary,
  };
};

export default ApiSummary();
